/**
 * tdesign v1.6.6
 * (c) 2023 tdesign
 * @license MIT
 */

import { ref } from '@vue/composition-api';

function useHover(props, _ref) {
  var emit = _ref.emit;
  var disabled = props.disabled,
    readonly = props.readonly,
    onMouseenter = props.onMouseenter,
    onMouseleave = props.onMouseleave;
  var isHover = ref(false);
  var addHover = function addHover(context) {
    if (readonly.value || disabled.value) return;
    isHover.value = true;
    onMouseenter === null || onMouseenter === void 0 || onMouseenter(context);
    emit("mouseenter", context);
  };
  var cancelHover = function cancelHover(context) {
    if (readonly.value || disabled.value) return;
    isHover.value = false;
    onMouseleave === null || onMouseleave === void 0 || onMouseleave(context);
    emit("mouseleave", context);
  };
  return {
    isHover: isHover,
    addHover: addHover,
    cancelHover: cancelHover
  };
}

export { useHover as default };
//# sourceMappingURL=useHover.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/tdesign-vue/es/tag-input/hooks/useHover.js
// module id = null
// module chunks = 